import React from "react";

import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import {Button} from "reactstrap";
import ReactTable from "react-table";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import moment from "moment";
import {Link} from "react-router-dom";
import MenuItem from "@material-ui/core/MenuItem";
import TextField from "@material-ui/core/TextField";
import MailIcon from '@material-ui/icons/Mail';
import APPCONFIG from "constants/Config";

const KIND_LABELS = {
	av_renewal_reminder: 'Upcoming reminder',
	av_renewal_invoice: 'Renewal Payment Confirmation',
	av_key_repush: 'Key Resent',
	av_portal_link: 'Payment Update Link',
	av_renewal_checkout: 'Renewal Checkout',
	av_payment_link: 'Payment link',
	av_signup_quantity: 'Signup quantity',
	feedback_review_1day: 'Feedback review (1 day)',
	feedback_review_1week: 'Feedback review (1 week)',
};

export default class AutomatedEmails extends Framework.Components.Collection {
	constructor(props) {
		let model = new API.BuildClass(Types.Automated_Emails._name, API.RequestType.READ_ALL);
		super(props, model);
		this.state.limit = 20;
		this.state.emailKind = 'all';
		this.state.highlightRow = this.getHighlightPkeyFromLocation();
		this.rowRefs = {};
	}

	getHighlightPkeyFromLocation = () => {
		const location = this.props.history?.location;
		if (!location) {
			return null;
		}
		const searchParams = new URLSearchParams(location.search || '');
		const searchPkey = searchParams.get('pkey');
		if (searchPkey != null && searchPkey !== '') {
			const parsed = Number(searchPkey);
			return Number.isNaN(parsed) ? null : parsed;
		}
		const hash = location.hash || '';
		if (hash.includes('pkey=')) {
			const queryString = hash.includes('?') ? hash.split('?')[1] : hash.replace(/^#/, '');
			const params = new URLSearchParams(queryString);
			const pkey = params.get('pkey');
			if (pkey != null && pkey !== '') {
				const parsed = Number(pkey);
				return Number.isNaN(parsed) ? null : parsed;
			}
		}
		return null;
	}

	applyHighlight = (data = this.state.data) => {
		const pkey = this.state.highlightRow;
		if (!pkey) {
			return;
		}
		const rows = Array.isArray(data) ? data : [];
		const matchIndex = rows.findIndex((row) => Number(row.pkey) === Number(pkey));
		const nextState = {};
		if (matchIndex >= 0 && this.state.limit) {
			nextState.page = Math.floor(matchIndex / this.state.limit);
		}
		this.setState(nextState, () => {
			const row = this.rowRefs[pkey];
			if (row && typeof row.scrollIntoView === 'function') {
				row.scrollIntoView({behavior: 'smooth', block: 'center'});
			}
		});
	}

	fetchData = async (state) => {
		if (typeof (this.state.filter) === "undefined" || Array.isArray(this.state.filter)) {
			this.state.filter = {};
		}
		if (this.state.emailKind && this.state.emailKind !== 'all') {
			this.state.filter.kind = this.state.emailKind;
		} else {
			delete this.state.filter.kind;
		}
		delete this.state.filter.email_kind;
		const highlightPkey = this.getHighlightPkeyFromLocation();
		if (highlightPkey) {
			this.state.filter.highlight_pkey = highlightPkey;
			this.state.highlightRow = highlightPkey;
		} else {
			delete this.state.filter.highlight_pkey;
		}
		this.model.filter = this.state.filter;
		this.setState({loading: true, highlightRow: highlightPkey || this.state.highlightRow});
		window.setTimeout(async () => {
			await this.fetchDataActual(state);
			this.applyHighlight();
		}, 100);
	}

	snapshotUrl = (row) => {
		if (!row.has_snapshot || !row.pkey) {
			return null;
		}
		return APPCONFIG.settings.apiURL() + "/" + APPCONFIG.settings.apiVersion + "/automated_emails/" + row.pkey;
	}

	render() {
		const {data, pages, limit, loading, emailKind, highlightRow} = this.state;
		const columns = [
			{
				Header: "Date Sent",
				id: "created",
				width: 180,
				accessor: obj => obj.created ? moment(obj.created).local().format("MM/DD/YYYY h:mm A") : '-',
				Cell: (props) => {
					const pkey = props.original?.pkey;
					return (
						<div ref={(el) => {
							if (pkey) {
								this.rowRefs[pkey] = el;
							}
						}}>
							{props.value}
						</div>
					);
				}
			},
			{
				Header: "Kind",
				id: "email_kind",
				accessor: obj => KIND_LABELS[obj.email_kind] || obj.email_kind || '-'
			},
			{
				Header: "Customer",
				id: "customer",
				Cell: (props) => {
					const row = props.original;
					if (row.customer) {
						return <Link to={`/customers/${row.customer}`}>{row.customer_name || `#${row.customer}`}</Link>;
					}
					return row.customer_name || '-';
				}
			},
			{
				Header: "Email Address",
				id: "sent_to",
				accessor: obj => obj.sent_to || '-'
			},
			{
				Header: "Opened",
				id: "email_opened",
				accessor: obj => obj.email_opened ? moment(obj.email_opened).local().format("MM/DD/YYYY h:mm A") : '-'
			},
			{
				Header: "",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 45,
				Cell: props => {
					const url = this.snapshotUrl(props.original);
					if (!url) {
						return null;
					}
					return (
						<span>
							<a href={url} target={'_blank'} rel="noopener noreferrer">
								<Button color="green-meadow" size="sm" block={true}>
									<MailIcon fontSize={'small'}/>
								</Button>
							</a>
						</span>
					);
				}
			},
		];

		return (
			<Card>
				<CardContent>
					<div className="table-bar">
						<div className="d-flex align-items-center">
							<TextField
								select
								label="Kind"
								value={emailKind}
								onChange={(e) => this.setState({ emailKind: e.target.value }, () => this.fetchData())}
								margin="dense"
								style={{ minWidth: 260, marginRight: 16 }}
							>
								<MenuItem value="all">All</MenuItem>
								<MenuItem value="av_renewal_reminder">Upcoming reminders</MenuItem>
								<MenuItem value="av_renewal_invoice">Renewal Payment Confirmation</MenuItem>
								<MenuItem value="av_key_repush">Key Resent</MenuItem>
								<MenuItem value="av_portal_link">Payment Update Link</MenuItem>
								<MenuItem value="av_renewal_checkout">Renewal Checkout</MenuItem>
								<MenuItem value="av_payment_link">Payment link</MenuItem>
								<MenuItem value="av_signup_quantity">Signup quantity</MenuItem>
								<MenuItem value="feedback_review_1day">Feedback review (1 day)</MenuItem>
								<MenuItem value="feedback_review_1week">Feedback review (1 week)</MenuItem>
							</TextField>
							{this.renderSearch('Emails', "")}
							{this.renderHeaderRight("Emails", columns)}
						</div>
					</div>
					<ReactTable
						key={this.state.key}
						columns={columns}
						manual
						data={data}
						pages={pages}
						loading={loading}
						loadingText="Requesting Data"
						onFetchData={this.fetchData}
						onPageSizeChange={this.onPageSizeChange}
						defaultSorted={[{ id: 'created', desc: true }]}
						showPagination={true}
						defaultPageSize={limit}
						pageSize={limit}
						className="-striped -highlight"
						getTrProps={(state, rowInfo) => {
							const pkey = rowInfo?.original?.pkey;
							const highlighted = pkey != null && Number(pkey) === Number(highlightRow);
							return {
								style: {
									background: highlighted ? '#ffcccc' : undefined,
								},
							};
						}}
					/>
					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		)
	}
}
